import React from 'react';
import ContactSection from '../components/sections/ContactSection';

const Contact = () => {
  return (
    <div>
      <section className="hero" style={{ padding: '3rem 0' }}>
        <div className="container">
          <h2>Contact Us</h2>
          <p>We're Here to Help</p>
        </div>
      </section>

      <ContactSection />
    </div>
  );
};

export default Contact;
